import { useLingui } from '@lingui/react/macro';
import { styled } from '@linaria/react';
import { type WorkspaceHalfDaySlots } from 'app-shared/types';
import { Field, Input } from 'app-ui/primitives/input';
import { themeCssVariables } from 'app-ui/theme';
import { type Control, Controller } from 'react-hook-form';
import { type InterventionFormValues } from '@/intervention/types/InterventionFormValues';
import { ReferenceSelect } from '@/reference-data/components/ReferenceSelect';
const StyledPair = styled.div`
  display: grid;
  gap: ${themeCssVariables.spacing[3]};
  grid-template-columns: 1fr 1fr;
`;
type InterventionScheduleFieldsProps = {
  control: Control<InterventionFormValues>;
  halfDaySlots: WorkspaceHalfDaySlots;
  disabled: boolean;
  onScheduleChange: () => void;
};
export const InterventionScheduleFields = ({
  control,
  halfDaySlots,
  disabled,
  onScheduleChange,
}: InterventionScheduleFieldsProps) => {
  const { t } = useLingui();
  const options = [
    {
      value: 'morning',
      label: `${t`Morning`} · ${halfDaySlots.morning.start}–${halfDaySlots.morning.end}`,
    },
    {
      value: 'afternoon',
      label: `${t`Afternoon`} · ${halfDaySlots.afternoon.start}–${halfDaySlots.afternoon.end}`,
    },
  ];
  return (
    <>
      {(['start', 'end'] as const).map((boundary) => (
        <StyledPair key={boundary}>
          <Controller
            control={control}
            name={boundary === 'start' ? 'startDay' : 'endDay'}
            render={({ field }) => (
              <Field.Root>
                <Field.Label>
                  {boundary === 'start' ? t`Start date` : t`End date`}
                </Field.Label>
                <Input
                  type="date"
                  ref={field.ref}
                  name={field.name}
                  value={field.value}
                  disabled={disabled}
                  onValueChange={(day) => {
                    field.onChange(day);
                    onScheduleChange();
                  }}
                  onBlur={field.onBlur}
                />
              </Field.Root>
            )}
          />
          <Controller
            control={control}
            name={boundary === 'start' ? 'startHalfDay' : 'endHalfDay'}
            render={({ field }) => (
              <ReferenceSelect
                label={
                  boundary === 'start' ? t`Start half-day` : t`End half-day`
                }
                value={field.value}
                options={options}
                disabled={disabled}
                onChange={(halfDay) => {
                  field.onChange(halfDay);
                  onScheduleChange();
                }}
              />
            )}
          />
        </StyledPair>
      ))}
    </>
  );
};
